import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import withRouter from "components/Common/withRouter";

// API
import AuthenticationApi from "../../Api/AuthenticationApi";

// assets
import user1 from "../../assets/images/users/user-1.jpg";

// actions
import { editProfile, resetProfileFlag } from "../../store/actions";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./user-profile.scss"

const UserProfile = () => {
  //meta title
  document.title = "Profile | Pixwik ";

  const dispatch = useDispatch();
  const accessToken = localStorage.getItem("accessToken")
  const userData = JSON.parse(localStorage.getItem("userData"))

  const [email, setemail] = useState("");
  const [name, setname] = useState("");
  const [idx, setidx] = useState(1);

  const selectProfileState = (state) => state.Profile;
  const ProfileProperties = createSelector(
    selectProfileState,
    (profile) => ({
      error: profile.error,
      success: profile.success,
    })
  );

  const {
    error,
    success
  } = useSelector(ProfileProperties);

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        setname(obj.displayName);
        setemail(obj.email);
        setidx(obj.uid);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        setname(obj.username);
        setemail(obj.email);
        setidx(obj.uid);
      }
      setTimeout(() => {
        dispatch(resetProfileFlag());
      }, 3000);
    }
  }, [dispatch, success]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: name || '',
      idx: idx || '',
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your UserName"),
    }),
    onSubmit: (values) => {
      dispatch(editProfile(values));
      toast.success("Username updated successfully!");
    },
  });

  const passwordValidation = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",

    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Please enter your old password."),
      newPassword: Yup.string()
        .min(6, "Password must be at least 6 characters long.")
        .required("Please enter a new password."),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }

        await AuthenticationApi.changePassword({
          email: userData.email,
          oldPassword: values.oldPassword,
          password: values.newPassword,

        }, config);
        toast.success("Password updated successfully!");
        resetForm();
      } catch (error) {
        toast.error("Failed to update password. Please try again.");
      }
    },
  });

  return (
    <React.Fragment>
      <div className="page-content p-0">
        <Container fluid>
          <Row>
            <Col lg="12">
              {error && error ? <Alert color="danger">{error}</Alert> : null}
              {success ? <Alert color="success">{success}</Alert> : null}

              <h4 className="card-title mb-4">Profile</h4>

              <Card>
                <CardBody>
                  <div className="d-flex gap-3">
                    <div className="ms-3">
                      <span className="user-profile rounded-circle">
                        {userData?.userName?.charAt(0).toUpperCase()}
                      </span>
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5 className="userName ">{userData.userName}</h5>
                        <p className="mb-1">{userData.email}</p>

                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">Change Password</h4>

          <Card>
            <CardBody>
              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault();
                  passwordValidation.handleSubmit();
                  return false;
                }}
              >
                <div className="form-group">
                  <Label className="form-label">Old Password</Label>
                  <Input
                    name="oldPassword"
                    className="form-control"
                    placeholder="Enter Old Password"
                    type="password"
                    onChange={passwordValidation.handleChange}
                    onBlur={passwordValidation.handleBlur}
                    value={passwordValidation.values.oldPassword || ""}
                    invalid={
                      passwordValidation.touched.oldPassword &&
                        passwordValidation.errors.oldPassword
                        ? true
                        : false
                    }
                  />
                  {passwordValidation.touched.oldPassword &&
                    passwordValidation.errors.oldPassword ? (
                    <FormFeedback type="invalid">
                      {passwordValidation.errors.oldPassword}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="form-group">
                  <Label className="form-label mt-4">New Password</Label>
                  <Input
                    name="newPassword"
                    className="form-control"
                    placeholder="Enter New Password"
                    type="password"
                    onChange={passwordValidation.handleChange}
                    onBlur={passwordValidation.handleBlur}
                    value={passwordValidation.values.newPassword || ""}
                    invalid={
                      passwordValidation.touched.newPassword &&
                        passwordValidation.errors.newPassword
                        ? true
                        : false
                    }
                  />
                  {passwordValidation.touched.newPassword &&
                    passwordValidation.errors.newPassword ? (
                    <FormFeedback type="invalid">
                      {passwordValidation.errors.newPassword}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="danger">
                    Change Password
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>

          <h4 className="card-title mb-4">Change User Name</h4>

          <Card>
            <CardBody>
              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <div className="form-group">
                  <Label className="form-label">User Name</Label>
                  <Input
                    name="username"
                    className="form-control"
                    placeholder="Enter User Name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.username || ""}
                    invalid={
                      validation.touched.username && validation.errors.username
                        ? true
                        : false
                    }
                  />
                  {validation.touched.username && validation.errors.username ? (
                    <FormFeedback type="invalid">
                      {validation.errors.username}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="text-center mt-4">
                  <Button type="submit" color="danger">
                    Update User Name
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
